module.exports = __webpack_public_path__ + "img/operatingSystem.efda1680.jpg";